import { Link, Outlet, useLocation } from 'react-router-dom'
import { ThemeDropdown } from '@/components/ThemeDropdown'
import { Button } from '@/components/ui/button'

export function PublicLayout() {
  const location = useLocation()
  const isLogin = location.pathname.startsWith('/login')

  return (
    <div className="min-h-screen bg-[#f6faff]">
      <header className="sticky top-0 z-40 border-b border-border/70 bg-background/95 backdrop-blur">
        <div className="mx-auto flex h-14 max-w-7xl items-center justify-between gap-4 px-4 sm:px-6 lg:px-8">
          <div className="flex min-w-0 items-center gap-6">
            <Link to="/" className="truncate text-lg font-bold tracking-[-0.04em] text-foreground">
              EtherPilot
            </Link>
          </div>

          <div className="flex items-center gap-2">
            <ThemeDropdown />
            {!isLogin ? (
              <Button asChild variant="outline" size="sm" className="border-border/70 bg-background">
                <Link to="/login">Sign In</Link>
              </Button>
            ) : null}
          </div>
        </div>
      </header>

      <Outlet />
    </div>
  )
}
